// extracted by mini-css-extract-plugin
export default {"main_wrap":"UseProvisionPage_main_wrap__8CWoM"};